import { Box } from "@mui/material";
import React from "react";
import MainHeader from "../../shared/MainHeader";

import MyOpenCaseTable from "../../components/MyOpenCaseTable";

const OpenCases = () => {
  return (
    <Box>
      <MainHeader headingText={"My Open Cases"} />

      <MyOpenCaseTable />
    </Box>
  );
};

export default OpenCases;
